/**
 * 时间单位
 */
export enum E_TimeUnit {
    MilliSecond = 'MS',
    Second = 'S',
    Minute = 'M',
    Hour = 'H',
    Day = 'D',
}

export function toMilliSecond(value: number, unit: E_TimeUnit) {
    const table = {
        [E_TimeUnit.MilliSecond]: 1,
        [E_TimeUnit.Second]: 1000,
        [E_TimeUnit.Minute]: 60 * 1000,
        [E_TimeUnit.Hour]: 60 * 60 * 1000,
        [E_TimeUnit.Day]: 60 * 60 * 24 * 1000,
    }
    return table[unit] * value
}

export function toSeconds(value: number, unit: E_TimeUnit) {
    const table = {
        [E_TimeUnit.MilliSecond]: 1 / 1000,
        [E_TimeUnit.Second]: 1,
        [E_TimeUnit.Minute]: 60,
        [E_TimeUnit.Hour]: 60 * 60,
        [E_TimeUnit.Day]: 60 * 60 * 24,
    }
    return table[unit] * value
}

export function toMinute(value: number, unit: E_TimeUnit) {
    const table = {
        [E_TimeUnit.MilliSecond]: 1 / (1000 * 60),
        [E_TimeUnit.Second]: 1 / 60,
        [E_TimeUnit.Minute]: 1,
        [E_TimeUnit.Hour]: 60,
        [E_TimeUnit.Day]: 60 * 24,
    }
    return table[unit] * value
}

export enum E_DateUnit {
    Day = 'Day',
    Month = 'Month',
    Year = 'Year',
}

export function toDays(value: number, unit: E_DateUnit) {
    const table = {
        [E_DateUnit.Day]: 1,
        [E_DateUnit.Month]: 30,
        [E_DateUnit.Year]: 365,
    }
    return table[unit] * value
}
